import React from 'react';
import DefaultLoadingScreen from 'common/components/DefaultLoadingScreen/DefaultLoadingScreen';
import ErrorResponseScreen from 'common/components/ErrorResponseScreen/ErrorResponseScreen';
import SnackbarAutoClose from 'common/components/SnackbarAutoClose/SnackbarAutoClose';

const config = {
  page: {
    loading: DefaultLoadingScreen,
    error: ErrorResponseScreen,
  },
  snackbar: {
    error: props => (
      <SnackbarAutoClose
        message={props.error.message}
        actionText="Close"
        type="ERROR"
      />
    ),
    success: props => (
      <SnackbarAutoClose
        message={props.message}
        actionText="Close"
        type="SUCCESS"
      />
    ),
  },
};

export default config;
